<h1 mat-dialog-title>{{ data.day | date: "EEEE, MMMM d" }}</h1>
<div mat-dialog-content>
  <app-calendar-list-day [events]="data.eventMap" [day]="data.day" [class.modal]="true"></app-calendar-list-day>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="accent" [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</div>
